canopyPublic.controller("ErrorController", ["$scope", "$stateParams", function ($scope, $stateParams) {
	var init = function () {
		$scope.response = {
			code: $stateParams.code
		};
	};
			
	init();
}]);